export enum Actions {
  GET_PROJECTS_PENDING = 'GET_PROJECTS_PENDING',
  GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS',
  GET_PROJECTS_ERROR = 'GET_PROJECTS_ERROR',
  GET_PROJECT_BY_ID_SUCCESS = 'GET_PROJECT_BY_ID_SUCCESS',
  GET_PROJECT_BY_ID_PENDING = 'GET_PROJECT_BY_ID_PENDING',
  GET_PROJECT_BY_ID_ERROR = 'GET_PROJECT_BY_ID_ERROR',
  CREATE_PROJECT_SUCCESS = 'CREATE_PROJECT_SUCCESS',
  CREATE_PROJECT_PENDING = 'CREATE_PROJECT_PENDING',
  CREATE_PROJECT_ERROR = 'CREATE_PROJECT_ERROR',
  EDIT_PROJECT_SUCCESS = 'EDIT_PROJECT_SUCCESS',
  EDIT_PROJECT_PENDING = 'EDIT_PROJECT_PENDING',
  EDIT_PROJECT_ERROR = 'EDIT_PROJECT_ERROR',
  DELETE_PROJECT_PENDING = 'DELETE_PROJECT_PENDING',
  DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS',
  DELETE_PROJECT_ERROR = 'DELETE_PROJECT_ERROR',
  CLEAN_SELECTED_PROJECT = 'CLEAN_SELECTED_PROJECT',
  GET_PROJECT_REPORT_PENDING = 'GET_PROJECT_REPORT_PENDING',
  GET_PROJECT_REPORT_SUCCESS = 'GET_PROJECT_REPORT_SUCCESS',
  GET_PROJECT_REPORT_ERROR = 'GET_PROJECT_REPORT_ERROR',
}
